<template>
  <div class="dashboard-module" :class="{ 'mb24': showGap }">
    <div class="dashboard-head" :class="{ 'dashboard-head-operation': hasOperation }">
      <div class="dashboard-head-title" v-if="titleSlot">
        <slot name="title" />
      </div>
      <div class="dashboard-head-title" v-else>{{ title }}</div>
      <div class="dashboard-head-ope">
        <slot name="ope"></slot>
      </div>
    </div>
    <div class="dashboard-main">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: "DashboardModule",
    props: {
      title: {
        type: String,
        default: ''
      },
      showGap: {
        type: Boolean,
        default: false
      },
      titleSlot: {
        type: Boolean,
        default: false
      },
      hasOperation: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dashboard-module {
    background-color: #fff;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    .dashboard-head {
      padding: 5px 20px 5px 20px;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      font-size: 18px;
      border-bottom: 1px solid #f3f3f3;
      .dashboard-head-title {
        line-height: 40px;
      }
      .title-icon {
        font-size: 21px;
        margin-right: 14px;
      }
      .title-year {
        font-size: 19px;
      }
      .dashboard-head-ope {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      &.dashboard-head-operation {
        .dashboard-head-title {
          width: 230px;
        }
        .dashboard-head-ope {
          width: calc(100% - 180px);
        }
      }
    }
    .dashboard-main {
      padding: 20px;
      .chart {
        width: 100%;
      }
      .chart-empty {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        flex-direction: column;
      }
    }
  }
</style>
